import { AppDispatch } from '@/store/index';
import { DictionarySlice } from '@/store/reducers/DictionaryReducer';
import { DictionariesService } from '@services/DictionariesService';
import { FavoritesService } from '@services/FavoritesService';
import { IField } from '@models/IFormData';
import { sendModalMsg } from '@srm/ui/lib/modalMessages';
import { isRequestCanceled } from '@srm/core/http';

/** Схема в сторе одна на страницу: переход к другому справочнику отменяет загрузку прежнего. */
let schemeRequest: AbortController | undefined;

export const DictionaryActionCreators = {
    fetchDictionaryScheme: (dictName: string) => async (dispatch: AppDispatch) => {
        schemeRequest?.abort();
        const request = new AbortController();
        schemeRequest = request;
        try {
            dispatch(DictionarySlice.actions.setIsLoading(true));
            const response = await DictionariesService.fetchDictionaryScheme(dictName, request.signal);
            if (request.signal.aborted) return;
            dispatch(DictionarySlice.actions.successLoadDictionaryScheme(response.data));
        } catch (e) {
            if (isRequestCanceled(e, request.signal)) return;
            console.log(e);
            let error = e as string[];
            sendModalMsg({
                message: error,
                type: 'error',
            });
        } finally {
            if (schemeRequest === request) {
                schemeRequest = undefined;
                dispatch(DictionarySlice.actions.setIsLoading(false));
            }
        }
    },
    updateDictionaryItem:
        (dictName: string, id: string, attributes: IField[], structIds: string[], callbackFn?: () => void) =>
        async (dispatch: AppDispatch) => {
            try {
                dispatch(DictionarySlice.actions.setIsLoading(true));
                await DictionariesService.updateItem(dictName, id, attributes, structIds);
                callbackFn && callbackFn();
            } catch (e) {
                console.log(e);
                let error = e as string[];
                sendModalMsg({
                    message: error,
                    type: 'error',
                });
            } finally {
                dispatch(DictionarySlice.actions.setIsLoading(false));
            }
        },

    addDictionaryItem:
        (dictName: string, attributes: IField[], structIds: string[], callbackFn?: () => void, parentId?: string) =>
        async (dispatch: AppDispatch) => {
            try {
                dispatch(DictionarySlice.actions.setIsLoading(true));
                await DictionariesService.addItem(dictName, attributes, structIds, parentId);
                callbackFn && callbackFn();
            } catch (e) {
                console.log(e);
                let error = e as string[];
                sendModalMsg({
                    message: error,
                    type: 'error',
                });
            } finally {
                dispatch(DictionarySlice.actions.setIsLoading(false));
            }
        },
    removeDictFromFavorites: (rootDictionaryId?: string, templateName?: string) => async (dispatch: AppDispatch) => {
        try {
            if (rootDictionaryId && !templateName) {
                await FavoritesService.removeDictionaryFromFavorites(rootDictionaryId);
            } else if (templateName) {
                await FavoritesService.removeFormDataDictionaryFromFavorites(templateName);
            } else {
                return;
            }

            dispatch(DictionarySlice.actions.setIsFavorite(false));
        } catch (e) {
            console.log(e);
            let error = e as string[];
            sendModalMsg({
                message: error,
                type: 'error',
            });
        }
    },
    addDictToFavorites: (rootDictionaryId?: string, templateName?: string) => async (dispatch: AppDispatch) => {
        try {
            if (rootDictionaryId && !templateName) {
                await FavoritesService.addDictionaryToFavorites(rootDictionaryId);
            } else if (templateName) {
                await FavoritesService.addFormDataDictionaryToFavorites(templateName);
            } else {
                return;
            }

            dispatch(DictionarySlice.actions.setIsFavorite(true));
        } catch (e) {
            console.log(e);
            let error = e as string[];
            sendModalMsg({
                message: error,
                type: 'error',
            });
        }
    },

    checkDictionaryIsFavorite: (dictionaryId?: string, template?: string) => async (dispatch: AppDispatch) => {
        try {
            let response;
            if (dictionaryId) {
                response = await FavoritesService.checkIsFavoriteDictionary(dictionaryId);
            } else if (template) {
                response = await FavoritesService.checkIsFavoriteFormDataDictionary(template);
            } else {
                dispatch(DictionarySlice.actions.setIsFavorite(false));
                return;
            }
            if (response && response.data !== undefined)
                dispatch(DictionarySlice.actions.setIsFavorite(response.data as boolean));
        } catch (e) {
            console.log(e);
            let error = e as string[];
            sendModalMsg({
                message: error,
                type: 'error',
            });
        }
    },
};
